import api from "../axios_service.js";


export async function uploadAvatar(id, fd) {
  const response = await api.post(`/usuarios/${id}/avatar`, fd);
  return response;
}
